import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { Topics } from "@common/interfaces/topics";
import { EntityState, EntityStore, EntityUIStore } from "@datorama/akita";
import { IProjectCategory } from '@common/interfaces/projectCategory';

export interface ProjectCategoryState extends EntityState<IProjectCategory, string> { };

export type JProjectCategoryUI = { id: string, expanded: boolean }
export interface ProjectCategoryUIState extends EntityState<JProjectCategoryUI ,string> { }

@Injectable({ providedIn: 'root' })
@PersistedStoreConfig({ name: Topics.PROJECT_CATEGORIES, realtimeEntity: 'ProjectCategory', persistUiStore: true, resettable: true })
export class ProjectCategoryStore extends EntityStore<ProjectCategoryState> {

  ui: EntityUIStore<ProjectCategoryUIState>;

  constructor() {
    super();
    this.createUIStore().setInitialEntityState({ expanded: true });
  }
}
